'use client';

import { Suspense } from 'react';
import Loader from '@/legacy/styled-components/components/Loader';
import { NavigationBlockerProvider } from '@/providers/NavigationBlocker';
import { NavigationStateProvider } from '@/providers/NavigationStateProvider';
import AppShell from './AppShell';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <NavigationBlockerProvider>
      <NavigationStateProvider>
        <Suspense fallback={<Loader />}>
          <AppShell>{children}</AppShell>
        </Suspense>
      </NavigationStateProvider>
    </NavigationBlockerProvider>
  );
}
